import { datatableInit } from "../functions/datatableInit";
import Swal from 'sweetalert2'

const regionsList = () => {

    $(document).on('click', '.remove-regions', function (e){
        e.preventDefault()
        const id = $(this).data('id')

        Swal.fire({
            icon: 'question',
            title: 'Czy na pewno chcesz usunąć region?',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showCancelButton: true,
            cancelButtonText: 'Nie, anuluj',
            showConfirmButton: true,
            confirmButtonText: 'Tak, usuń',
            cancelButtonColor: '#6c757d',
            confirmButtonColor: '#dc3545'
        }).then(result => {
            if (result.isConfirmed)
            {
                $.ajax({
                    type: 'post',
                    url: Routing.generate('region_remove', {id: id}),
                }).done(d => {
                    if (!d.error)
                    {
                        Swal.fire({
                            icon: 'success',
                            title: 'Region został usunięty',
                            showCancelButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            cancelButtonText: 'Zamknij',
                            cancelButtonColor: '#3f51b5',
                        }).then( () => {
                            location.reload()
                        })
                    }
                    else
                    {
                        Swal.fire({
                            icon: 'error',
                            title: 'Nie udało się usunąć regionu',
                            text: d.error,
                            confirmButtonText: 'Zamknij',
                            confirmButtonColor: '#3f51b5',
                        })
                    }

                })
            }
            else
            {
                Swal.fire({
                    icon: 'warning',
                    title: 'Anulowano usuwanie regionu',
                    confirmButtonText: 'Zamknij',
                    confirmButtonColor: '#3f51b5',
                })

            }
        })
    })

    $(() => {

        datatableInit('.datatable')

    })

}

window.initRegionsList = () => {
    regionsList()
}